export const validColors = ['primary', 'secondary', 'info', 'success', 'warning', 'danger'];

const getThemeColor = (theme, color, variant = 'main') => {
  if (!validColors.includes(color)) {
    return variant === 'contrastText' ? theme.palette.grey[900] : theme.palette.grey[300];
  }

  return theme.palette[color][variant];
};

export default getThemeColor;
